import L from 'leaflet';
import MapPin from './_MapPin';
import { mergeClasses } from '@griffel/react';
import { MAP_MIN_ZOOM } from '../map/MapConstants';

export default class ExteriorMapPin extends MapPin 
{
	constructor(id, latlng, texts, lang = 'ja', options = {}) 
	{
		super(id, latlng, texts, lang, options);

		this._monumentID = options.monumentID || id;
	}

	initVars(options = {}) 
	{
		this._markerClassName = mergeClasses('common', 'exterior');
		this._tooltipClassName = mergeClasses('common', 'exterior');

		this._tooltipDirection = options.tooltipDirection;
	}

	updateTooltipPosition() 
	{
		const tooltipOptions = this.getTooltipOptions();

		this.setTooltipOptions(tooltipOptions);
	}

	getTooltipOptions(options)
	{
		if (!this._texts)
		{
			return null;
		}

		const mult_x = Math.pow(1.4, this._zoomLevel - MAP_MIN_ZOOM);
		const mult_y = Math.pow(1.2, this._zoomLevel - MAP_MIN_ZOOM);

		const icon_w = 8;
		const icon_h = 14;

		let tooltipDirection = this._tooltipDirection || 'right';
		let tooltipOffset = L.point(0, 0);

		if (options && options.tooltipDirection)
		{
			tooltipDirection = options.tooltipDirection;
		}

		const tx = icon_w * mult_x * .5;
		const ty1 = icon_h * mult_y * .75;
		const ty2 = icon_h * mult_y * 1.5;

		switch (tooltipDirection)
		{
			case 'left':
				tooltipOffset = L.point(-tx, -ty1);
				break;
			case 'right':
				tooltipOffset = L.point(tx, -ty1);
				break;
			case 'top':
				tooltipOffset = L.point(0, -ty2);
				break;
			case 'bottom':
				tooltipOffset = L.point(0, 0);
				break;
			default:
				tooltipOffset = L.point(tx, -ty1); // Default to right
				break;
		}

		// Tooltip options
		const tooltipOptions =
		{
			className: ['map-pin', this._tooltipClassName].join(' '),
			direction: tooltipDirection,
			offset: tooltipOffset,
			permanent: true
		};

		return tooltipOptions;
	}

	setTooltipOptions(tooltipOptions)
	{
		const tooltip = this.getTooltip();
		if (tooltip && this._map && this._map.getContainer())
		{
			tooltip.options = { ...tooltip.options, ...tooltipOptions };
			
			// Only update if the tooltip is currently open and the map is ready
			if (tooltip.isOpen() && this._map.getContainer())
			{
				tooltip.update();
			}
		}
	}

	makeHTML(options = {}) 
	{
		const svg = `
			<svg class="pin exterior" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87.28 120">
				<path class="base" d="m87.28,43.64C87.28,18.97,66.81-.91,41.94.03,19.37.89.97,19.24.04,41.8c-.52,12.57,4.29,24.01,12.34,32.28,9.02,9.25,16.7,19.72,22.21,31.41l6.13,13.01c.95,2.01,3.81,2.01,4.76,0l4.89-10.37c5.77-12.23,13.48-23.52,23.29-32.82,8.39-7.95,13.62-19.2,13.62-31.67Z"/>
				<g class="icon">
					<circle cx="43.64" cy="30" r="7.22"/>
					<circle cx="30.75" cy="52.85" r="7.22"/>
					<circle cx="56.53" cy="52.85" r="7.22"/>
				</g>
			</svg>
		`;

		return `
		<div class="pin-scale">
			<div class="pin-inner">
				${svg}
			</div>
		</div>`;
	}

	handleUpdateZoom()
	{
		this.updateTooltipPosition();
	}
}